/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var T,A;!function(T){T[T.OBJECT=0]="OBJECT",T[T.ENTITY=1]="ENTITY",T[T.RELATIONSHIP=2]="RELATIONSHIP",T[T.PATH=3]="PATH",T[T.ARRAY=4]="ARRAY"}(T||(T={})),function(T){T[T.view=0]="view",T[T.edit=1]="edit"}(A||(A={}));export{T as WasmGraphQueryResponseTypeCodes,A as WasmQuantizeModeCodes};
